import { AccountJwt } from "@common/domain";
import { createAction, props } from "@ngrx/store";
import {
  IAMAccountPasswordUpdateCmd,
  IAMAccountSignInCmd
} from "@youm-front/iam-account/domain";

export const iamAccountPasswordUpdate = createAction(
  "[IAMAccount] Password Update",
  props<{ iamAccountPasswordUpdateCmd: IAMAccountPasswordUpdateCmd }>()
);
export const iamAccountPasswordUpdateSuccess = createAction(
  "[IAMAccount] Password Update Success"
);
export const iamAccountPasswordUpdateFailure = createAction(
  "[IAMAccount] Password Update Failure",
  props<{ error: string }>()
);

export const iamAccountSignIn = createAction(
  "[IAMAccount] Sign In",
  props<{ iamAccountSignInCmd: IAMAccountSignInCmd }>()
);
export const iamAccountSignInSuccess = createAction(
  "[IAMAccount] Sign In Success",
  props<{ jwt: AccountJwt }>()
);
export const iamAccountSignInFailure = createAction(
  "[IAMAccount] Sign In Failure",
  props<{ error: string }>()
);
